import { reportsClient } from './client';
import { ConnectError, Code } from '@connectrpc/connect';
import { create } from '@bufbuild/protobuf';
import {
  GetSpendingSummaryRequestSchema,
  type GetSpendingSummaryResponse,
} from '../../generated/reports/v1/reports_pb';

/**
 * Get spending summary report from the backend
 * User ID is extracted from JWT token by auth interceptor
 */
export const getSpendingSummary = async (
  year?: number,
  month?: number
): Promise<GetSpendingSummaryResponse> => {
  try {
    const request = create(GetSpendingSummaryRequestSchema, {
      year: year,
      month: month,
    });

    const response = await reportsClient.getSpendingSummary(request);
    return response;
  } catch (error) {
    console.error('Get spending summary failed:', error);
    throw handleReportsError(error, 'get spending summary');
  }
};

/**
 * Handle reports API errors with proper error code checking
 */
function handleReportsError(error: unknown, operation: string): Error {
  if (error instanceof ConnectError) {
    if (error.code === Code.Unauthenticated) {
      return new Error('Session expired. Please log in again.');
    }
    if (error.code === Code.PermissionDenied) {
      return new Error('Access denied. You do not have permission to perform this action.');
    }

    const message = error.message || '';
    if (
      message.includes('Load failed') ||
      message.includes('Failed to fetch') ||
      message.includes('NetworkError')
    ) {
      return new Error(
        `Failed to ${operation}: Network error. Please check your connection and try again.`
      );
    }

    if (error.message) {
      return new Error(`Failed to ${operation}: ${error.message}`);
    }
  }

  return new Error(
    `Failed to ${operation}: ${error instanceof Error ? error.message : 'Unknown error'}`
  );
}
